import getRandomInt from '../functions/getRandomInt';
export default function random(w) {
    if (w === undefined) {
        const words = ['MATHEMATICS', 'ARITHMETIC', 'GEOMETRY', 'ALGEBRA',
            'DIFFERENTIAL', 'INFINITIES', 'CALCULUS', 'INTEGRATION', 'STATISTICS',
            'PROBABILITY', 'ANALYSIS', 'GRAPHICAL', 'APPROXIMATION', 'PERMUTATION',
            'COMBINATION', 'EXPONENTIAL', 'FACTORIAL', 'ADDITION', 'SUBTRACTION',
            'IMAGINARY', 'QUOTIENT', 'RATIONAL', 'IRRATIONAL', 'TRIGONOMETRY',
            'CONVERGENCE', 'UNDEFINED', 'PYTHAGORAS', 'SEQUENCE', 'SERIES', 'FUNCTION',
            'GAUSSIAN', 'QUADRATIC', 'EULER', 'AXIOM', 'MULTIPLICATION', 'DIVISION',
            'FORMULA', 'COMPOSITION', 'CORRELATION', 'HYPOTHESIS', 'EXPANSION', 'TRANSFORM',
            'EXISTENCE', 'MATHEMATICAL', 'PARAMETRIC'];
        const index = getRandomInt(0, words.length - 1);
        return words[index];
    }
    else {
        return w;
    }
}
